import { useToast } from 'hooks/useToast'
import { useState } from 'react'

type UseDragAndDropReturn = {
	dragActive: boolean
	handleDragOver: (e: React.DragEvent<HTMLDivElement>) => void
	handleDragLeave: (e: React.DragEvent<HTMLDivElement>) => void
	handleDrop: (e: React.DragEvent<HTMLDivElement>) => void
}

function useDragAndDrop(
	handleFile: (file: File) => void,
	typeAllowed: string,
	messageError = 'File not allowed'
): UseDragAndDropReturn {
	const [dragActive, setDragActive] = useState(false)
	const { showToast } = useToast()

	const handleDragOver = (e: React.DragEvent<HTMLDivElement>): void => {
		e.preventDefault()
		e.stopPropagation()
		setDragActive(true)
	}

	const handleDragLeave = (e: React.DragEvent<HTMLDivElement>): void => {
		e.preventDefault()
		e.stopPropagation()
		setDragActive(false)
	}

	const handleDrop = (e: React.DragEvent<HTMLDivElement>): void => {
		e.preventDefault()
		e.stopPropagation()
		setDragActive(false)

		const droppedFile = e.dataTransfer.files[0]
		if (droppedFile && droppedFile.type === typeAllowed) {
			handleFile(droppedFile)
		} else {
			showToast('Error', messageError, 'error')
		}
	}

	return { dragActive, handleDragOver, handleDragLeave, handleDrop }
}

export default useDragAndDrop
